import {authService, userService} from "../../client/connection/Services";
import {UserPreferencesStore, TopUpPaymentStore, PaymentStore, SubscriptionStore, DonationStore} from "../State";
import {iFrameConnection} from "./IFrameConnection";
import {IFrameMessages} from "../../blink-sdk/messaging/IFrameMessages";
import {iFrameState} from "./IFrameState";
import {isDeepEqual, isString} from "../UtilsLib";
import {apiUpdatePreferences} from "../../client/state/UserPreferencesStore";
import {Dispatchable} from "../../stem-core/src/base/Dispatcher";
import {iFrameMerchantService} from "./IframeMerchantService";
import {iFrameUserDataService} from "./IFrameUserDataService";
import {MerchantAudienceMemberStore} from "../../client/state/merchant/MerchantAudienceMemberStore";
import {StemDate} from "../../stem-core/src/time/Date";
import {TimeUnit} from "../../stem-core/src/time/Duration";
import {TNR_ALIAS} from "../../blink-sdk/Constants";
import {MerchantUserStore} from "../../client/state/merchant/MerchantUserStore";


// TODO: Rename this. Maybe split the functionality.
class IFrameBlinkService extends Dispatchable {
    lastSdkUserData = null;

    init() {
        this.updateSdkUserData();
        this.addListeners();
        this.addConnectionDispatchers();
    }

    addListeners() {
        // We need the sdk user data to be updated when we get all those flow checkpoint events. That is why we can't
        // rely on the iFrameUserDataService which sends those change events in an desynchronized way.
        SubscriptionStore.addChangeListener(() => this.updateSdkUserData());
        DonationStore.addChangeListener(() => this.updateSdkUserData());
        iFrameUserDataService.addUpdateListener(() => this.updateSdkUserData());
        authService.onAuthenticationChange(() => this.updateSdkUserData());
        UserPreferencesStore.addChangeListener(() => this.updateSdkUserData());
        MerchantUserStore.addChangeListener(() => this.updateSdkUserData());
        iFrameState.addUpdateListener(() => this.updateSdkUserData());
    }

    addConnectionDispatchers() {
        TopUpPaymentStore.addCreateListener(topUp => this.showPaymentAnimation(topUp.getAmount()));
        PaymentStore.addCreateListener(purchase => this.showPaymentAnimation(purchase.getDebitedAmount()));
    }

    updateSdkUserData() {
        const sdkUserData = this.getSdkUserData();
        if (isDeepEqual(sdkUserData, this.lastSdkUserData)) {
            return;
        }
        this.lastSdkUserData = sdkUserData;
        iFrameConnection.sendToSDK(IFrameMessages.UPDATE_SDK_USER_DATA, {userData: sdkUserData});
    }

    getSerializedSubscription() {
        const subscription = iFrameUserDataService.getActiveSubscription();
        if (subscription) {
            return subscription.serializeForSDK();
        }
        const emailAddress = userService.getUserEmail();
        if (iFrameMerchantService.isMerchant(TNR_ALIAS) && isString(emailAddress) && emailAddress.indexOf("@tnr.com") >= 0) {
            return {
                id: "fake-tnr",
                currencyCode: "usd",
                deliveryAddressId: null,
                blinkSignature: null,
                nextPaymentAttempt: null,
                userId: userService.getUserId(),
                amount: 20000000,
                createdAt: StemDate.now().format(),
                canceledAt: null,
                activeUntil: StemDate.now().addUnit(TimeUnit.MONTH).format(),
            };
        }
        return null;
    }

    getSdkUserData() {
        const defaultSdkUserData = {
            userId: null,
            alwaysShowBalance: null,
            subscription: null,
            showOnboarding: null,
            activeRecurringDonation: null,
            latestOneTimeDonation: null,
            newsletterIds: [],
        };
        const preferences = UserPreferencesStore.getPreferences();

        if (!authService.isAuthenticated() || !preferences) {
            return defaultSdkUserData;
        }

        const {showOnboarding} = preferences;
        if (showOnboarding) {
            preferences.showOnboarding = false;
            apiUpdatePreferences(preferences.getFields());
        }

        const activeRecurringDonation = iFrameUserDataService.getActiveRecurringDonation();
        const latestOneTimeDonation = iFrameUserDataService.getLatestOneTimeDonation();

        return {
            ...defaultSdkUserData,
            userId: userService.getUserId(),
            alwaysShowBalance: preferences.shouldShowBalanceInline(),
            subscription: this.getSerializedSubscription(),
            showOnboarding,
            activeRecurringDonation: activeRecurringDonation ? activeRecurringDonation.serializeForSDK() : null,
            latestOneTimeDonation: latestOneTimeDonation ? latestOneTimeDonation.serializeForSDK() : null,
            newsletterIds: MerchantAudienceMemberStore.filter(member => member.isSubscribed()).map(newsletterMember => newsletterMember.audienceId),
        };
    }

    showPaymentAnimation(payment) {
        const userPreferences = UserPreferencesStore.getPreferences();
        if (payment.getAmount() > 0 && userPreferences && userPreferences.showPaymentAnimation) {
            iFrameConnection.sendToSDK(IFrameMessages.SESSION_PAYMENT_MADE);
        }
    }
}

export const iFrameBlinkService = new IFrameBlinkService();
